var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorPicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#DAC6E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0125 16.1845C13.2055 16.6832 13.4828 17.2021 13.915 17.5954C13.7506 18.5035 12.9559 19.1923 12.0004 19.1923C11.0389 19.1923 10.2402 18.4948 10.0828 17.5781C10.562 17.1319 10.8751 16.5792 11.0925 16.0293C11.3559 15.3628 11.4988 14.6465 11.6122 14.0432C11.6221 13.9906 11.6317 13.9392 11.6411 13.8889C11.7472 13.322 11.8255 12.9034 11.9423 12.6053C11.9648 12.5477 11.9853 12.5045 12.0025 12.4727C12.0279 12.5142 12.0603 12.5768 12.0984 12.6697C12.2439 13.0247 12.3485 13.5327 12.4829 14.1856L12.4855 14.1982C12.6129 14.8175 12.764 15.5423 13.0125 16.1845ZM11.9562 12.4093C11.9442 12.4044 11.9386 12.3987 11.9388 12.397C11.939 12.3954 11.945 12.3978 11.9562 12.4093Z",
    stroke: "#272932",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76367 4.2002L10.5141 8.46471",
    stroke: "#272932",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5742 4.7168L13.5658 8.86603",
    stroke: "#272932",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03125 8.66309L9.06694 10.9545",
    stroke: "#272932",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6162 9.18945L15.3241 10.9545",
    stroke: "#272932",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7193 15.2451C19.5296 15.715 18.8651 15.9555 18.2486 15.5299L16.2465 14.148C16.0645 14.0224 15.9245 13.8123 15.8365 13.4879C15.7473 13.1591 15.7269 12.7634 15.7517 12.3582C15.7936 11.675 15.6481 10.9934 15.331 10.3869C15.0139 9.78035 14.5372 9.27192 13.9523 8.91646C13.3674 8.561 12.6966 8.37199 12.0121 8.36984C11.3277 8.36769 10.6557 8.55248 10.0686 8.90426C9.48148 9.25604 9.00157 9.76146 8.68066 10.366C8.35974 10.9705 8.20999 11.6512 8.24757 12.3346C8.26985 12.74 8.24692 13.1355 8.15565 13.4638C8.06564 13.7876 7.9243 13.9968 7.74153 14.1212L5.73085 15.4906C5.11166 15.9123 4.44863 15.6676 4.26188 15.1966C3.93272 14.3664 3.73781 13.4849 3.68834 12.5853C3.60511 11.0716 3.93679 9.56398 4.64759 8.22501C5.35839 6.88604 6.42133 5.76658 7.72171 4.98742C9.0221 4.20827 10.5106 3.79899 12.0265 3.80375C13.5424 3.80852 15.0283 4.22714 16.3237 5.01446C17.6192 5.80177 18.6751 6.92789 19.3775 8.2713C20.0798 9.61471 20.402 11.1244 20.3093 12.6375C20.2542 13.5368 20.0537 14.4171 19.7193 15.2451Z",
    stroke: "#272932",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPicker);
export default __webpack_public_path__ + "static/media/Color Picker.38a71dd865dfbf635bea3ebb0ae7b195.svg";
export { ForwardRef as ReactComponent };